import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {
  CreateApplicationNoteFn,
  InsurancePremiumApplication,
  isInternalUser,
  User,
  DigitalIdGetApplicationIndividualsFn,
  RemoveApplicationNoteByNoteIdFn,
  GetRateCardDetailsFn,
  RatecardDetails,
  getLoanTerms,
  AppCalculator,
  getBrokerageAmount,
  InsurancePremiumCalculatorData,
  getTotalAmount,
  RefreshBankStatementFn,
  GetUserFn,
  GetBankStatementsAnalysisFn,
  DownloadDocumentFromAzureFn,
  UpdateApplicationStageInSfFn,
  GetApplicationByIdFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  AssetSettlementGetApplicationAssetFn, GetDisbursementByApplicationIdFn, SettleLoanFn, GetBsaLenderListFn, GetBsaExcludedLenderListFn, GetDscrCalculatorValueFn, UpdateDscrCalculatorValueFn, SaveBsaCalculatorFn, GetBsaCalculatorFn, GetDscrCalculatorHistoryFn, RunCreditFlowFn, GetCreditWebServicesFn, GetApplicationCreditFlowResultFn, DownloadCreditorWatchReportFn, UpdateCreditStatusFn, GetCreditAuditLogFn, ApplicationSelectionObject, GetWebServiceReportFn, GetDuplicatedApplicationsFn, DuplicatedApplication, DeleteWebServicesFn,
  GetBasiqCustomerMappingFn, GetBasiqStatementDataForCompanyFn, RefreshBasiqConnectionsFn, GetBankStatementAndBasiqDataStatusFn, RequestMoreInformationFn, WithdrawApplicationFn, Application, GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  AggregatorAndOriginatorListValueGetFn,
  NewWebService,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
} from '@portal-workspace/grow-shared-library';
import { BreadcrumbComponentEvent, BreadcrumbComponent } from '../../breadcrumb-component/breadcrumb.component';
import {ApplicationSelectionType, applicationEntityDisplayName, getApplicationStage} from '@portal-workspace/grow-shared-library';
import {
  ApproveApplicationDocumentFn, DeclineApplicationDocumentFn, DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn, DownloadAllApplicationDocumentUrlFn, DownloadApplicationDocumentUrlFn,
  GetOriginatorByIdFn, ListApplicationDocumentFn,
  BusinessSearchFn,
   UpdateApplicationDocumentTagsFn, UpdateApplicationRequiredDocumentsFn,
  CreateDocumentWorklistFn, CompleteDocumentWorklistFn, GetNotesByApplicationIdFn,
  BusinessNumberSearchFn,
  UndoApplicationDocumentFn, AssetDocumentsComponent, CorporateLoansDocumentsComponent, GetApplicationAuditLogsFn,
  ApplicationDialogService,
} from '@portal-workspace/grow-ui-library';
import {UpdateApplicationDocumentFn} from '../application-details.module';
import {GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent} from '@portal-workspace/grow-ui-library';
import {getUser } from '@portal-workspace/grow-ui-library';
import {Subscription} from 'rxjs';
import {UntilDestroy} from '@ngneat/until-destroy';
import {tap} from 'rxjs/operators';
import _ from 'lodash';
import { InsuranceDocumentsComponent } from './insurance-documents.component';
import { KycVerificationComponent } from '../kyc-verification.component';
import { confirmLeaveKycAmlTab } from '../kyc-unsaved-tab-guard';
import { InsuranceAppComponent } from './insurance-app.component';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import { ApplicationStageIconComponent } from '../application-stage-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { BankComponent } from '../bank.component';
import {ApplicationTypeIconComponent} from '../../application-type-icon/application-type-icon.component';
import { InsuranceCreditComponent } from './insurance-credit.component';
import { CreditReportComponent } from '../../credit-component/credit-report.component';
import { MessageBoxComponent } from '../../message-box/message-box.component';

export type InsuranceTab = {selectionTypes: ApplicationSelectionType[], iconClass: string, name: string, index: number};

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
  selector: 'insurance-premium-application-details',
  templateUrl: './insurance-premium-application-details.component.html',
  styleUrls: ['./insurance-premium-application-details.component.scss'],
  standalone: true,
  imports: [
    FlexModule,
    BreadcrumbComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    ApplicationStageIconComponent,
    MatTabsModule,
    InsuranceAppComponent,
    KycVerificationComponent,
    InsuranceDocumentsComponent,
    BankComponent,
    AssetDocumentsComponent,
    CorporateLoansDocumentsComponent,
    ApplicationTypeIconComponent,
    InsuranceCreditComponent,
    CreditReportComponent,
    MessageBoxComponent,
  ]
})
export class InsurancePremiumApplicationDetailsComponent {

  tabs: InsuranceTab[] = [];

  // possible selections that can be access directly through URL
  possibleSelections: ApplicationSelectionType[] = ['app', 'quote', 'bank-statement', 'documents', 'kyc-aml', 'credit-report'];

  @Input({required: true}) getOriginatorByIdFn!: GetOriginatorByIdFn;
  @Input({required: true}) addIndividualFn!: DigitalIdAddIndividualFn;
  @Input({required: true}) verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  @Input({required: true}) sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  @Input({required: true}) getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  @Input({required: true}) saveApplicationPartiesFn!: SaveApplicationPartiesFn;
  @Input({required: true}) businessSearchFn!: BusinessSearchFn;
  @Input({required: true}) updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  @Input({required: true}) listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input({required: true}) downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input({required: true}) approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input({required: true}) declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input({required: true}) deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input({required: true}) downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input({required: true}) updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input({required: true}) updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
  @Input({required: true}) createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input({required: true}) completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;
  @Input({required: true}) undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input({required: true}) refreshBankStatementFn!: RefreshBankStatementFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) bankStatementsUrl!: string;
  @Input({required: true}) application!: InsurancePremiumApplication;

  @Input({required: false}) initialSelection: ApplicationSelectionType | null = null;
  @Input({required: true}) businessNumberSearchFn!: BusinessNumberSearchFn;
  @Input({required: true}) downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Output() selectionEvent: EventEmitter<ApplicationSelectionObject> = new EventEmitter<ApplicationSelectionObject>();

  @Input({required: true}) generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input({required: true}) sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input({required: true}) deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input({required: true}) updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input({required: true}) getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input({required: true}) getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input({required: true}) settleLoanFn!: SettleLoanFn;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;

  breadcrumbTrails: string[] = ['Applications'];
  loggedInUser: User | null = getUser();
  subscriptions: Subscription[] = [];
  data!: InsurancePremiumCalculatorData;


  @Input({required: true}) onBreadcrumbEventsFn: (evt: BreadcrumbComponentEvent)=>void = (evt)=>{};

  currentSection: ApplicationSelectionType = 'app';
  currentSectionIndex: number = 0;

  @ViewChild(KycVerificationComponent) kycVerification?: KycVerificationComponent;

  constructor(private dialogService: ApplicationDialogService) {}

  @Input({required: true}) uploadApplicationDocumentFn!: UpdateApplicationDocumentFn;
  @Input({required: true}) getRatecardDetailsFn!: GetRateCardDetailsFn;
  @Input({required: true}) getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input({required: true}) getBsaLenderListFn!: GetBsaLenderListFn;
  @Input({required: true}) getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  @Input({required: true}) getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  @Input({required: true}) updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;
  @Input({required: true}) saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  @Input({required: true}) getBsaCalculatorFn!: GetBsaCalculatorFn;
  @Input({required: true}) getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  @Input({required: true}) getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  @Input({required: true}) getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  @Input({required: true}) refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({required: true}) getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input({required: true}) updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  @Input() syncIndividualKycFromFrankieOneFn?: DigitalIdSyncIndividualKycFromFrankieOneFn;

  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;
  @Output() navigateToApplications = new EventEmitter();
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  isInternalUser = isInternalUser;
  getApplicationStage = getApplicationStage;

  initTabs() {
    this.tabs = [];
    this.tabs.push({selectionTypes: ['app'], iconClass: 'mdi-view-grid-outline', name: 'APPLICATION', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['bank-statement'], iconClass: 'mdi-bank-outline', name: 'BANK STATEMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['kyc-aml'], iconClass: 'mdi-check-decagram-outline', name: 'CUSTOMER DETAILS(KYC/AML)', index:(this.tabs.length)});
    if (isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['credit', 'credit-report'], iconClass: 'mdi-calculator', name: 'CREDIT', index: (this.tabs.length)});
    }
    this.tabs.push({selectionTypes: ['documents'], iconClass: 'mdi-folder-outline', name: 'DOCUMENTS', index: (this.tabs.length)});
  }

  hasUnsavedKycChanges(): boolean {
    return this.currentSection === 'kyc-aml' && !!this.kycVerification?.hasUnsavedChanges();
  }

  unsavedKycChangeLabels(): string[] {
    return this.kycVerification?.unsavedChangeLabels() ?? [];
  }

  async onSelectedTabChange(event: MatTabChangeEvent) {
    const previousSection = this.currentSection;
    const tabFound = this.tabs.find(t => t.index == event.index);
    const selection = tabFound ? tabFound.selectionTypes[0] : 'app' /* default selection if not found */ ;
    const canLeave = await confirmLeaveKycAmlTab({
      previousSection,
      nextSection: selection,
      kycVerification: this.kycVerification,
      dialogService: this.dialogService,
      revertToKycTab: () => {
        const kycTab = this.tabs.find(t => t.selectionTypes.includes('kyc-aml'));
        if (kycTab) {
          this.currentSectionIndex = kycTab.index;
        }
      },
    });
    if (!canLeave) {
      return;
    }
    this.currentSection = selection;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  ngOnInit() {
    this.initTabs();
    const routeTab = this.initialSelection;
    if (routeTab && this.possibleSelections.includes(routeTab)) {
      const _tab = this.tabs.find(tab => tab.selectionTypes.includes(routeTab));
      if (_tab) {
        this.currentSection = routeTab;
        this.currentSectionIndex = _tab.index;
      }
    }
    const entityName = applicationEntityDisplayName(this.application);
    if (entityName) {
      this.breadcrumbTrails.push(entityName);
    }

    this.subscriptions.push(
      this.getRatecardDetailsFn(this.application.UserId, 'InsurancePremium').pipe(
        tap((r: RatecardDetails) => {
          const rateCard = r;
          const loanTerms = getLoanTerms(this.application);
          const totalAmount = Number(getTotalAmount(this.application));
          const brokerageAmountSf = getBrokerageAmount(this.application);

          const calculator = new AppCalculator();
          const terms = calculator.getTotalInterestRateForInsurancePremiumFinance(rateCard!, {totalPremiumAmount: totalAmount});

          const interestRate = terms.totalInterest / 100;
          const interestAmount = interestRate * totalAmount;
          const docFee = terms.docFee;
          const brokerageAmount = brokerageAmountSf !== undefined ? brokerageAmountSf : _.round((interestAmount * 20 / 100 ), 2);
          const repayment = _.round(totalAmount * (1  + interestRate) / loanTerms, 2);
          this.data = {
            monthlyInstallment: repayment,
            applicationFee: docFee,
            brokerage: brokerageAmount,
          };
          console.log(this.data)
        })
      ).subscribe()
    )
  }

  onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    this.onBreadcrumbEventsFn($event);
  }

  onViewReport(element: NewWebService) {
    this.currentSection = 'credit-report';
    console.log(this.currentSection)
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: String(element.id),
    });
  }

  onLeaveReport(event: void) {
    this.currentSection = 'credit';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
